export class UpdatePersonaCuentaContableRequest{
  public id!:number
  public idCuentaContable!:number
  public idPersona!:number
  public activo!: boolean
  public descripcion!: string
}
